<script setup>
import * as amplitude from "@amplitude/analytics-browser";

const props = defineProps({
  toggle: Function,
  errorCode: String
});

const tryAgain = () => {
  props.toggle(false);
  amplitude.track("Scan another QR code", window.amplitudeCommonProperties);
};
</script>

<template>
<div class="flex flex-col items-center justify-center gap-12 px-5">
  <img class="mt-9 w-full max-w-28" src="../../assets/icons/alert-octagon.svg" alt="" />
  <div class="flex flex-col gap-3 text-center">
    <h1 class="text-2xl font-bold">
      {{ $t("backend_error.unexpected_error") }}
    </h1>
    <p class="text-[20px]">
      {{ $t("backend_error.try_again_later") }}
    </p>
    <p v-if="errorCode.length > 0" class="text-lg text-[#999999]">
      ({{ $t("backend_error.error_code", { code: errorCode }) }})
    </p>
  </div>
  <div class="flex flex-col items-center gap-5">
    <button class="rounded bg-[var(--primary)] p-2.5 text-lg font-bold text-white" @click="tryAgain">
      {{ $t("backend_error.try_again") }}
    </button>
  </div>
</div>
</template>
